import { BaseUser, Role } from '@core/model/user.model';

export interface LoggedUser extends BaseUser {
  readonly fullName?: string;
  readonly role: LoggedUserRole;
}

export interface LoggedUserRole {
  name: Role;
  permissions: UserPermission[];
}

export interface UserPermission {
  readonly name: string;
}

export enum Permissions {
  // ADMIN
  canManageUsers = 'canManageUsers',
  canManageCompanies = 'canManageCompanies',
  canManagePermissions = 'canManagePermissions',
  canManagePayments = 'canManagePayments',
  canManageSubscriptions = 'canManageSubscriptions',
  canManageTickets = 'canManageTickets',
  canManageVouchers = 'canManageVouchers',
  canManageProducts = 'canManageProducts',
  canManageActivities = 'canManageActivities',
  canManageQuestionnaireFiles = 'canManageQuestionnaireFiles',
  canManageQuestionnaireVersion = 'canManageQuestionnaireVersion',
  canManageImprovementActionTemplates = 'canManageImprovementActionTemplates',
  canManageQuestionHelperTemplates = 'canManageQuestionHelperTemplates',
  canManageEmergenceTemplates = 'canManageEmergenceTemplates',
  canManageQuestionnaireMigrations = 'canManageQuestionnaireMigrations',
  canManageAffirmationFiles = 'canManageAffirmationFiles',
  canManageSlotTypes = 'canManageSlotTypes',
  canManageEnergyMeasuresTypes = 'canManageEnergyMeasuresTypes',
  canManageWorkflowYears = 'canManageWorkflowYears',
  canManageDoubleMaterialityTemplates = 'canManageDoubleMaterialityTemplates',
  canManageTables = 'canManageTables',
  canManageParameters = 'canManageParameters',
  canManageMedia = 'canManageMedia',
  canManageSelf = 'canManageSelf',
  canManageConfigData = 'canManageConfigData',
  canManageNoteTemplates = 'canManageNoteTemplates',
  canManageDocumentFolderTemplate = 'canManageDocumentFolderTemplate',
  canManageDesigner = 'canManageDesigner',
  canManageAffirmationGroup = 'canManageAffirmationGroup',
  canViewCompanies = 'canViewCompanies',
  canEditMetadata = 'canEditMetadata',
  canDeleteMediaTag = 'canDeleteMediaTag',

  // MAIN_USER
  canManageOwnUsers = 'canManageOwnUsers',
  canSubscribe = 'canSubscribe',
  canManageOwnCompany = 'canManageOwnCompany',
  canManageConfigurations = 'canManageConfigurations',
  canOpenTickets = 'canOpenTickets',
  hasPaidSubscription = 'hasPaidSubscription',

  // TUTOR
  canManageOwnCompanies = 'canManageOwnCompanies',
}
